import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers'
import { formatDateTimePickerValue } from 'hooks/date/formattedTime'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData } from 'types/final-protocol'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const CommissionEvaluationsProtocolTable = ({ protocolData }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields } = useFieldArray({
    control,
    name: `commissionEvaluations`,
  })

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          background: '#FFF',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('ordinal')}</TableCell>
            <TableCell>{t('name-surname-father-name')}</TableCell>
            <TableCell>{t('sign')}</TableCell>
            <TableCell>{t('date')}</TableCell>
            <TableCell>{t('commission-expert-note')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <StyledTableCell>
                  <Controller
                    name={`commissionEvaluations.${index}.memberName`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`commissionEvaluations.${index}.memberSignature`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    control={control}
                    name={`commissionEvaluations.${index}.decisionDate`}
                    render={({ field }) => (
                      <DateTimePicker
                        {...field}
                        ampm={false}
                        value={formatDateTimePickerValue(
                          protocolData.commissionEvaluations[index].decisionDate
                        )}
                        slotProps={{ textField: { error: false, fullWidth: true } }}
                        onChange={field.onChange}
                        timeSteps={{
                          hours: 1,
                          minutes: 1,
                        }}
                      />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`commissionEvaluations.${index}.specialNote`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
